import { BigNumber } from 'ethers'
import { ABI } from '../../abi'
import {
  IArgDict,
  IEditionMintStrategy,
  IPrivateMintFunctionArgs,
  IPublicMintFunctionArgs
} from './IEditionMintStrategy'

class Decent1155MintStrategy implements IEditionMintStrategy {
  getAbi() {
    return ABI.DCNTSeries
  }
  getPublicMintFunctionName(): string {
    return 'mint'
  }
  getPublicMintFunctionArgsDict({
    currentWalletAddress,
    mintCount
  }: IPublicMintFunctionArgs): IArgDict[] {
    // The 1 is for tokenId 1, which we always use for each 1155 edition.
    return [
      { name: 'tokenId', value: BigNumber.from(1) },
      { name: 'to', value: currentWalletAddress },
      {
        name: 'quantity',
        value: mintCount === '$QUANTITY' ? mintCount : BigNumber.from(mintCount) // '$QUANTITY' is used for Paper XYZ Payments
      }
    ]
  }

  getPresaleMintFunctionName(): string {
    return 'mintPresale'
  }

  getPresaleMintFunctionArgsDicts({
    currentWalletAddress,
    mintCount,
    maxPurchasablePerWallet,
    preSalePrice,
    merkleProof
  }: IPrivateMintFunctionArgs): IArgDict[] {
    return [
      { name: 'to', value: currentWalletAddress },
      // The 1 is for tokenId 1, which we always use for each 1155 edition.
      { name: 'tokenId', value: BigNumber.from(1) },
      {
        name: 'quantity',
        value: mintCount === '$QUANTITY' ? mintCount : BigNumber.from(mintCount) // '$QUANTITY' is used for Paper XYZ Payments,
      },
      { name: 'maxQuantity', value: BigNumber.from(maxPurchasablePerWallet) },
      { name: 'pricePerToken', value: BigNumber.from(preSalePrice) },
      { name: 'merkleProof', value: merkleProof || [] }
    ]
  }

  getMintTotalFunctionName(): string {
    return 'totalSupply'
  }
  getMintTotalArgs(): any[] | undefined {
    return [BigNumber.from(1)]
  }
  getMintTotalsFromData(data: any): { totalMinted: number; presaleMinted: number } {
    return {
      totalMinted: data.toNumber(),
      // We have no way to get the total presaleMinted from the decent contracts,
      // and no way to actually set an overall presale limit. So we just use
      // totalMinted for both.
      presaleMinted: data.toNumber()
    }
  }
}

export default new Decent1155MintStrategy()
